<template>
  <v-card>
    <v-card-title class="headline">
      Información de comisaría<br>
    </v-card-title>
    <v-card-text>
      <v-alert v-if="showAlert" color="warning" type="warning" class="mt-3">
        No hay información de comisaría asociada a la sede para la fase respectiva
      </v-alert>
      <div v-else-if="!data && !showAlert" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </div>
      <div v-else>
        <v-simple-table dense>
          <template #default>
            <tbody>
              <tr>
                <td><strong>UNIDAD</strong></td>
                <td class="text-left">
                  {{ data.pcsUnidad }}
                </td>
              </tr>
              <tr>
                <td><strong>GRADO JEFE</strong></td>
                <td class="text-left">
                  {{ data.pcsGradoJefe }}
                </td>
              </tr>
              <tr>
                <td><strong>NOMBRE JEFE</strong></td>
                <td class="text-left">
                  {{ data.pcsNombreJefe }}
                </td>
              </tr>
              <tr>
                <td><strong>TELÉFONO JEFE</strong></td>
                <td class="text-left">
                  {{ data.pcsTelefonoJefe }}
                </td>
              </tr>
              <tr>
                <td><strong>GRADO SUBROGANTE</strong></td>
                <td class="text-left">
                  {{ data.pcsGradoSubrogante }}
                </td>
              </tr>
              <tr>
                <td><strong>NOMBRE SUBROGANTE</strong></td>
                <td class="text-left">
                  {{ data.pcsNombreSubrogante }}
                </td>
              </tr>
              <tr>
                <td><strong>TELÉFONO SUBROGANTE</strong></td>
                <td class="text-left">
                  {{ data.pcsTelefonoSubrogante }}
                </td>
              </tr>
              <tr>
                <td><strong>DIRECCIÓN</strong></td>
                <td class="text-left">
                  {{ data.pcsDireccion }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card-text>
    <v-card-actions>
      <slot />
    </v-card-actions>
  </v-card>
</template>

<script>
import graphql from '../../utils/graphql';

export default {
  props: {
    sede: {
      type: Number,
      default: null
    },
    fase: {
      type: Number,
      default: null
    },
  },
  data: function() {
    return {
      data: null,
      showAlert: false,
    }
  },
  mounted() {
    this.comisaria();
  },
  methods: {
    async comisaria() {
      try {
        const query = {
          query: `
              query ($fspCodigo: Int!, $sedCodigo: Int!) {
                comisaria: comisariaBySedeFase(fspCodigo: $fspCodigo, sedCodigo: $sedCodigo) {
                    pcsUnidad
                    pcsGradoJefe
                    pcsNombreJefe
                    pcsTelefonoJefe
                    pcsGradoSubrogante
                    pcsNombreSubrogante
                    pcsTelefonoSubrogante
                    pcsDireccion
                }
              }
            `,
          variables : {
            fspCodigo: this.fase,
            sedCodigo: this.sede,
          }
        };
        const { comisaria } = await graphql.request(query);
        if (!comisaria) {
          this.showAlert = true;
        }
        this.data = comisaria;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
    }
  }
};
</script>
